<div class="container">
  <h2>{{ 'WORKOUT.WORKOUT-EXE.REGISTER-WEIGHT' | translate }}</h2>
  <a class="history-btn" (click)="history()">{{"WORKOUT.WORKOUT-EXE.WEIGHT-HISTORY"| translate}}</a>
  <div class="d-flex">
    <mat-form-field>
    <mat-label>{{ 'WORKOUT.WORKOUT-EXE.WEIGHT' | translate }}</mat-label>
    <input
      matInput
      placeholder="{{ 'WORKOUT.WORKOUT-EXE.WEIGHT' | translate }}"
      [(ngModel)]="weigth"
      required
    />
  </mat-form-field>

  <mat-form-field class="select-unit">
    <mat-label>Unità</mat-label>
    <mat-select [(ngModel)]="unit" required>
      <mat-option value="KG">{{ 'GENERIC.KG' | translate }}</mat-option>
      <mat-option value="LBS">{{ 'GENERIC.LBS' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
  </div>
   <button class="its-button confirm-weigth" (click)="confirmWeigth()">{{"GENERIC.CONFIRM" | translate}}</button>
</div>
